class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    this.isFirstClick = true;
    this.bindEvents();
  }

  bindEvents() {
    // Add mouse events for desktop
    if (this.mediaQuery.matches && !this.isTouchDevice) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => this.open());
      this.mainDetailsToggle.addEventListener('mouseleave', () => this.close());
      
      const summary = this.mainDetailsToggle.querySelector('summary');
      summary.addEventListener('click', (event) => {
        const link = summary.querySelector('a');
        if (link) {
          event.preventDefault();
          window.location.href = link.href;
        }
      });
    }

    // Handle touch devices
    if (this.isTouchDevice) {
      const summary = this.mainDetailsToggle.querySelector('summary');
      summary.addEventListener('click', this.handleTouchClick.bind(this));
    }

    // Watch for viewport changes
    this.mediaQuery.addEventListener('change', (event) => {
      if (event.matches && !this.isTouchDevice) {
        this.mainDetailsToggle.addEventListener('mouseenter', () => this.open());
        this.mainDetailsToggle.addEventListener('mouseleave', () => this.close());
      } else {
        this.mainDetailsToggle.removeEventListener('mouseenter', () => this.open());
        this.mainDetailsToggle.removeEventListener('mouseleave', () => this.close());
      }
    });
  }

  handleTouchClick(event) {
    const summary = event.currentTarget;
    const link = summary.querySelector('a');
    
    if (this.isFirstClick || !this.mainDetailsToggle.hasAttribute('open')) {
      event.preventDefault();
      this.isFirstClick = false;
      this.open();
    } else {
      this.isFirstClick = true;
      if (link) {
        window.location.href = link.href;
      }
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
